import { TaskManagementEventListDocument } from "api/generated";
import { RequestTypes } from "api/services/enums";
import { getRequestInstance } from "api/services/utils";

import {
  IListTaskManagementEventVars,
  ITaskManagementEventModel,
} from "./types";

export async function getTaskManagementEventList(
  variables: IListTaskManagementEventVars
): Promise<ITaskManagementEventModel[]> {
  try {
    const makeRequest = getRequestInstance(RequestTypes.QUERY);
    const res = await makeRequest({
      query: TaskManagementEventListDocument,
      variables,
      fetchPolicy: "network-only",
    });

    return res?.data?.taskManagementEventList ?? [];
  } catch (error) {
    throw error;
  }
}
